import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-validator/page.tsx");
